import { IdPrefixedObject, IdPrefixedResultObject } from "@/types/chat";

export const getIdPrefixedObjectFromArray = <T extends IdPrefixedObject>(
  array: T[],
): IdPrefixedResultObject<T> => {
  return array.reduce((acc, cur) => ({ ...acc, [String(cur.id)]: cur }), {});
};
